import React from 'react';

import { useAuth } from '../../../../hooks/index.js';
import { PatientIntakeStatusProvider } from '../PatientIntakeStatusProvider.tsx';
import { PatientIntakeStatusContent } from './PatientIntakeStatusContent.tsx';

type PatientIntakeStatusProps = {
  patientId?: string;
};

export const PatientIntakeStatus: React.FC<PatientIntakeStatusProps> = ({ patientId }) => {
  const { user } = useAuth();

  if (!user?.uid) {
    return null;
  }

  // If the patientId is not provided, then we assume the active user is the patient
  const patientIdToUse = patientId ?? user.uid;

  return (
    <PatientIntakeStatusProvider patientId={patientIdToUse}>
      <PatientIntakeStatusContent />
    </PatientIntakeStatusProvider>
  );
};
